var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NavBar'),_c('div',{staticClass:"pb-5",attrs:{"id":"app"}},[_c('router-view')],1),(_vm.showBottomNavBar)?_c('bottomNavBar'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }